import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";
import Button from "../../../components/Button/Button";

import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";
import CashlessBusinessMerchantLogos from "../../../images/bs-cashless-merchant-users-logos.png";

import "./CashlessBusinessOverviewWidget.css";
const CashlessBusinessOverviewWidget = () => {
    const data = useStaticQuery(graphql`
        query BsOfflineQuery {
            mobileImage: file(
                relativePath: { eq: "bs-cashless-mobile-1x-uc.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(relativePath: { eq: "bs-cashless-web-1x.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);
    return (
        <WidgetContainer stylesClass="cashless-business">
            <div id="cashless-business"></div>
            <div className="cashless-business__container">
                <div className="cashless-business__container__content">
                    <h2>Help your business go cashless</h2>
                    <p className="cashless-business__container__content__text">
                        Cash and card payments are no longer a complete solution
                        for your customers. Join the UPI revolution and grow
                        your sales by going cashless. PhonePe also offers
                        exclusive value added services to all its merchant
                        partners. You can list your store, add details and
                        offers to your store listing, enable the PhonePe ATM and
                        increase customer walk-ins with the PhonePe for Business
                        app.
                    </p>
                    <div className="cashless-business__container__content__banner">
                        <Img
                            fluid={data.mobileImage.childImageSharp.fluid}
                            alt="Cashless Payments with PhonePe"
                            imgStyle={{ objectFit: "cover" }}
                        />
                    </div>
                    <div className="cashless-business__container__content__btn-container">
                        <Button
                            btnText="Accept payments at stores"
                            pagePath="/business-solutions/offline-merchant/"
                            btnStyle="btnStyle"
                        />
                    </div>
                    <div className="cashless-business__container__content__merchant_logo">
                        <p>Popular Merchants</p>
                        <img
                            src={CashlessBusinessMerchantLogos}
                            alt="list of merchant logo of phonepe"
                        />
                    </div>
                </div>
                <div className="cashless-business__container__img">
                    <Img
                        fluid={data.desktopImage.childImageSharp.fluid}
                        alt="Cashless Payments with PhonePe"
                        imgStyle={{ objectFit: "cover" }}
                    />
                </div>
            </div>
        </WidgetContainer>
    );
};

export default CashlessBusinessOverviewWidget;
